import React, { useCallback, useContext, useEffect, useState } from 'react';
import EADataGrid from 'components/common/datatable/EADataGrid';
import { contextInstanceListColumns } from './ContextInstanceListColumns';
import { useHistory, useLocation } from 'react-router-dom';
import { useQuery } from '../../../config/Config';
import ContextDetail from '../ContextDetail';
import { Context } from '../../../states/Store';
import ContextTiers from '../ContextTiers';
import FicheContext from '../../../components/context/FicheContext';
import { getContextInstance } from '../../../services/edge/ContexteService';

const ContextDataTable = ({ contextInstanceList, fetchContextInstances }) => {
  const history = useHistory();
  const location = useLocation();
  const [state, dispatch] = useContext(Context);
  const queryUtil = useQuery();
  const urlInstanceId = parseInt(queryUtil.get('instance'));
  const urlThirdPartyId = parseInt(queryUtil.get('thirdparty'));
  const [selectedInstanceId, setSelectedInstanceId] = useState(urlInstanceId);
  const [selectedThirdPartyId, setSelectedThirdPartyId] = useState(
    urlThirdPartyId
  );
  const [selectedContext, setSelectedContext] = useState();

  useEffect(() => {
    dispatch({
      type: "CONTEXT_PAGINATION", context_pagination: {
        page: contextInstanceList.page,
        rowPerPage: contextInstanceList.size,
        count: contextInstanceList.totalElements
      }
    });
    return () => {
      dispatch({
        type: "CONTEXT_PAGINATION",
        context_pagination: {
          page: 0,
          rowPerPage: 50,
          count: 0,
        }
      });
    };
  }, [dispatch, contextInstanceList.page, contextInstanceList.size, contextInstanceList.totalElements]);

  useEffect(() => {
    dispatch({
      type: "CONTEXT_PAGINATION", context_pagination: {
        count: contextInstanceList.totalElements
      }
    });
  }, [contextInstanceList, dispatch])

  const fetchContextInstance = useCallback(async () => {
    try {
      if(selectedInstanceId && !isNaN(selectedInstanceId)) {
        const instance = await getContextInstance(
          state.account.id,
          Number(selectedInstanceId),
          dispatch
        );
        setSelectedContext(instance);
        dispatch({
          type: 'SELECTED_CONTEXT_INSTANCE',
          contextInstance: instance,
        });
      }
    } catch (e) {
      setSelectedContext(null);
    }
  }, [state.account, selectedInstanceId, dispatch]);

  useEffect(() => {
    fetchContextInstance();
  }, [fetchContextInstance]);

  useEffect(() => {
    const urlThirdPartyId = parseInt(queryUtil.get('thirdparty'));
    setSelectedThirdPartyId(urlThirdPartyId);
  }, [queryUtil]);

  useEffect(() => {
    if (!selectedContext) return;
    const sp = new URLSearchParams(location.search);
    const curr = sp.get('instance');
    const next = String(selectedContext.id);

    if (curr !== next) {
      sp.set('instance', next);
      history.replace({ pathname: location.pathname, search: sp.toString() });
    }
  }, [selectedContext, location.pathname, location.search, history]);

  const showContextDetail = (instanceId) => {
    setSelectedThirdPartyId(null);
    setSelectedInstanceId(instanceId);
    const searchParams = queryUtil;
    searchParams.delete('thirdparty');
    searchParams.set('instance', instanceId);
    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  const hideContextDetail = useCallback(() => {
    setSelectedInstanceId(null);
    setSelectedContext(null);
    const searchParams = queryUtil;
    searchParams.delete('instance');
    fetchContextInstances();
    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  }, [fetchContextInstances, history, location.pathname, queryUtil]);

  const hideThirdParty = useCallback(() => {
    setSelectedThirdPartyId(null);
    const searchParams = queryUtil;
    searchParams.delete('thirdparty');
    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  }, [history, location.pathname, queryUtil]);

  return (
    <>
      <EADataGrid
        loading={false}
        inputRows={contextInstanceList.content}
        getRowId={(row) => row.id}
        columns={contextInstanceListColumns(showContextDetail)}
        customSx={{
          '& .MuiDataGrid-columnHeader:nth-child(2)': { color: '#7E7E8F' },
        }}
        onRowClick={(row) => showContextDetail(row.id)}
        clickable={true}
        paginationMode={'server'}
        hasCustomPagination={true}
        rowCount={contextInstanceList.totalElements}
        paginationType={"CONTEXT_PAGINATION"}
        hasFilters={false}
      />
      {selectedInstanceId ? (
        <FicheContext
          handleClose={
            selectedThirdPartyId ? hideThirdParty : hideContextDetail
          }
          isOpen={!!selectedContext}
        >
          {selectedThirdPartyId ? (
            <ContextTiers
              contextInstanceId={selectedInstanceId}
              thirdPartyId={selectedThirdPartyId}
              selectedContext={selectedContext}
              setSelectedContext={setSelectedContext}
            />
          ) : (
            <ContextDetail
              fetchContextInstance={fetchContextInstance}
              onClose={hideContextDetail}
              contextInstanceList={contextInstanceList.content}
              selectedContext={selectedContext}
              setSelectedInstanceId={setSelectedInstanceId}
            />
          )}
        </FicheContext>
      ) : (
        <></>
      )}
    </>
  );
};

export default ContextDataTable;
